/**
 * Get the parent element of the given element
 *
 * Useful for getPopupContainer defaults
 * Note: getPopupContainer expects a node with position relative, or a descendant of a node with position relative.
 *
 * @param element
 */
export function getParentElement(element: HTMLElement) {
    return element.parentElement || document.body;
}
